import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-start justify-center gap-4 px-6">
      <h1 className="font-display text-5xl font-semibold tracking-tighter">Nothing playing here.</h1>
      <p className="text-muted-foreground">That page doesn&apos;t exist.</p>
      <Link to="/" className="text-primary underline underline-offset-4">
        Back to the dashboard
      </Link>
    </main>
  )
}
